import { render, staticRenderFns } from "./purchasehistory.vue?vue&type=template&id=555c7f42&scoped=true&"
import script from "./purchasehistory.vue?vue&type=script&lang=js&"
export * from "./purchasehistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c7f42",
  null
  
)

export default component.exports